import { z } from 'zod';

/**
 * Zod validation schema for contact form
 * Provides comprehensive client-side validation with Spanish error messages
 */
export const contactFormSchema = z.object({
  name: z.string()
    .min(2, 'El nombre debe tener al menos 2 caracteres')
    .max(100, 'El nombre no puede exceder 100 caracteres')
    .regex(/^[a-záéíóúñA-ZÁÉÍÓÚÑ\s]+$/, 'El nombre solo puede contener letras y espacios'),

  email: z.string()
    .min(1, 'El email es requerido')
    .email('Email inválido. Por favor ingresa un email válido')
    .max(255, 'El email no puede exceder 255 caracteres')
    .toLowerCase(),

  phone: z.string()
    .regex(
      /^[+]?[(]?[0-9]{1,4}[)]?[-\s.]?[(]?[0-9]{1,4}[)]?[-\s.]?[0-9]{1,9}$/,
      'Número de teléfono inválido. Formato: +57 300 123 4567'
    )
    .optional()
    .or(z.literal('')),

  message: z.string()
    .min(10, 'El mensaje debe tener al menos 10 caracteres')
    .max(1000, 'El mensaje no puede exceder 1000 caracteres'),

  // Optional fields that might be in the form
  subject: z.string()
    .min(1, 'Por favor selecciona un tipo de consulta')
    .optional()
    .or(z.literal('')),

  budget: z.string()
    .optional()
    .or(z.literal('')),

  zone: z.string()
    .max(200, 'La zona no puede exceder 200 caracteres')
    .optional()
    .or(z.literal('')),
});

/**
 * TypeScript type inferred from the Zod schema
 */
export type ContactFormData = z.infer<typeof contactFormSchema>;

/**
 * Default values for the form
 */
export const contactFormDefaults: ContactFormData = {
  name: '',
  email: '',
  phone: '',
  message: '',
  subject: '',
  budget: '',
  zone: '',
};
